/* eslint-disable @typescript-eslint/naming-convention */
import { PLBillDetailsData } from "./billDetailsPL";
import { BOOLEAN_AS_STRING } from "./Common";
import { CartItem } from "./menu-items";
import { CartCouponPositionXP, SelectiveCouponVariantXP, ValueDrivenCrossSellXP } from "./ReviewedCart";
import type { IColors } from "@swiggy-private/dls-web-common/dist/components/types";

export interface XPData {
    [key: string]: unknown;
    cart_apply_coupon_position?: CartCouponPositionXP;
    cancellation_popup_visible_for_new_user?: BOOLEAN_AS_STRING;
    show_correct_view_similar_cta?: BOOLEAN_AS_STRING;
    new_apply_coupon_listing_page_enabled?: BOOLEAN_AS_STRING;
    selective_coupon_widget_variant?: SelectiveCouponVariantXP;
    value_driven_cross_sell?: ValueDrivenCrossSellXP;
    self_instruction_half_card_enabled?: BOOLEAN_AS_STRING;
    disable_cart_address_selector?: BOOLEAN_AS_STRING;
    show_ph_nudge_in_cross_sell?: BOOLEAN_AS_STRING;
    show_ph_nudge_in_cross_sell_m4?: BOOLEAN_AS_STRING;
    savings_stamp_enabled?: BOOLEAN_AS_STRING;
    pilled_cross_sell_widget?: BOOLEAN_AS_STRING;
    bolt_3_0_xp?: BOOLEAN_AS_STRING;
}

export enum CartItemWidgetRepositionType {
    ADD_MORE_ITEMS = "ADD_MORE_ITEM",
    SEND_CUTLERY = "SEND_CUTLERY",
    COOKING_INSTRUCTIONS = "COOKING_INSTRUCTIONS",
    ADD_MESSAGE_ON_CAKE = "ADD_MESSAGE_ON_CAKE",
}
export interface CrossSellHeaderTitle {
    text: string;
    color?: string; // Token color name (e.g., "slateAlpha75")
    icon: string;
}
export interface CrossSellHeaderSubtitle {
    text: string;
    color: keyof IColors;
}
export interface CrossSellHeaderData {
    title: CrossSellHeaderTitle;
    subtitle: CrossSellHeaderSubtitle;
    lottie: string;
    background: string;
}
export interface WidgetPropertiesInfoProperties {
    is_widget_unlocked: boolean;
    amount_required_to_unlock: number;
}
export interface WidgetPropertiesInfo {
    type: string;
    properties: WidgetPropertiesInfoProperties;
}
export interface FlipTextItem {
    text: string;
    color: keyof IColors;
}
export interface ItemPresentationAttributes {
    flip_text?: FlipTextItem[];
}
export interface TimerTime {
    time_in_sec: number;
    color: keyof IColors;
    bg_color: keyof IColors;
}
export interface TimerData {
    remaining_time: TimerTime;
    urgency_time: TimerTime;
}
export interface CrossSellPresentationInfo {
    header_data?: CrossSellHeaderData;
    background?: string;
    widget_properties_info?: WidgetPropertiesInfo;
    item_presentation_attributes?: ItemPresentationAttributes;
    timer_data?: TimerData;
    ftue_animation?: {
        lottie?: string;
        threshold_limit?: number;
    };
}
export interface ICrossSellHeader {
    title?: string;
    subtitle?: string;
    presentationInfo?: CrossSellPresentationInfo;
}

export enum CrossSellTabType {
    POPULAR = "POPULAR",
    BEVERAGE = "BEVERAGE",
    SIDE = "SIDE",
    DESSERT = "DESSERT",
    MAGIC_ITEMS = "MAGIC_ITEMS",
}

interface AddCakeMessageWidgetConfig {
    max_characters_limit_per_cake_message: number;
    max_number_of_cakes_allowed: number;
    predefined_words_for_cake_message: string[];
    PMM_widget?: {
        arrow_color: string;
        image_id: string;
    };
}

export interface CartItemWidgetReposition {
    type: CartItemWidgetRepositionType;
    text?: string;
    config?: AddCakeMessageWidgetConfig;
}

export interface CrossSellTab {
    type?: CrossSellTabType;
    display_name?: string;
    cross_sell_suggestions: CartItem[];
}

export interface CrossSellInfo {
    cross_sell_tabs: CrossSellTab[];
    all_cross_sell_suggestions_added?: boolean;
    presentation_info?: CrossSellPresentationInfo;
    title?: string;
    subtitle?: string;
    icon?: string;
    all_cross_sell_suggestions_added_text?: string;
}

export interface Gradient {
    colours: string[];
    gradient_direction: string;
}

export interface SocialMarkerStyle {
    social_marker_type: string;
    title: string;
    gradient?: Gradient;
    text_style?: string;
    text_color?: string;
}

export interface DishStyle {
    social_marker_style?: SocialMarkerStyle[];
}

export interface MenuItemsWidgetPresentationData {
    dish_style?: DishStyle;
}

export enum PL_WIDGET_TYPES {
    BILL_DETAILS = "bill-details",
}
export interface PLWidgets {
    "widget-type": PL_WIDGET_TYPES;
    details: PLBillDetailsData;
}
export interface PLWidgetData {
    cards: PLWidgets[];
}
